export default __webpack_public_path__ + "static/media/right_sidebar_out_of_stack.ec66d50d.svg";